// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","374":"148e286e","453":"03346f77","455":"3b37999a","551":"8912905c","842":"01821987","869":"b6dda42b","977":"240addac"}[chunkId] + ".chunk.js";
};